import Commons from '../../../../Services/Common/Common';

export const M_Master_BASIC_Schema = {
  mapper: {
    search1: {
      SessionCd: (context) => Commons.EncryptAES(context.sessionCd.toString() ?? ''),
    },
    search2: {
      SessionCd: (context) => Commons.EncryptAES(context.sessionCd.toString() ?? ''),
    },
    search3: {
      SessionCd: (context) => Commons.EncryptAES(context.sessionCd.toString() ?? ''),
    },
    save1: {
      SessionCd: (row) => Commons.EncryptAES(row.sessionCd.toString() ?? ''),
      StepOrder: (row) => Commons.EncryptAES(row.stepOrder.toString() ?? ''),
      StepCode: (row) => Commons.EncryptAES(row.stepCode ?? ''),
      IsRequired: (row) => Commons.EncryptAES(row.isRequired ?? 'Y'),
      IsSkipAllowed: (row) => Commons.EncryptAES(row.isSkipAllowed ?? 'Y'),
      LastPosition: (row) => Commons.EncryptAES(row.lastPosition ?? '0'),
    },
    delete1: {
      SessionCd: (context) =>
        Commons.EncryptAES(context.sessionCd?.toString() ?? ''),
    },
  },
};
